import { Flex } from '@/components';
import { AnalysisSearchSkeleton } from '@/features/search/_components/analysis/skelton/AnalysisSearchSkeleton';
import { ProjectsSearchAccordionInitializeStore } from '@/features/search/_stores/ProjectsSearchAccordionInitializeStore';
import { useProjectsSearchStore } from '@/features/search/_stores/projects-search-store';
import type { FC } from 'react';
import { AnalysisSearchAccordion } from '../../search/_components/analysis/AnalysisSearchAccordion';
import { AnalysisResults } from '../_components/AnalysisResults';
import { AnalysisResultsSkeletonContents } from '../_components/AnalysisResultsSkeletonContents';
import {
  AnalysisSegmentSwitcher,
  sheetTypeToSegment,
} from '../_components/AnalysisSegmentSwitcher';
import { useAnalysisPageSearchQueryStates } from '../_hooks/search-query-states';
import {
  type AnalysisSheetType,
  AnalysisSheetTypeProvider,
} from '../_hooks/useAnalysisSheetType';
import { FundSheetAnalysisPage } from '../fund-sheet/_pages/FundSheetAnalysisPage';

type Props = {
  sheetType: AnalysisSheetType;
};

export const AnalysisPage: FC<Props> = ({ sheetType }) => {
  // 基金シート (KS) は RS 用クエリ/検索UI/結果 (useProjectAnalysis) とは別物のため、
  // KS 専用に組まれた FundSheetAnalysisPage へ委譲する。
  // これを行わないと、公開サイトの基金シートタブで RS 用の検索条件・API が走り、
  // 「データがありません」になる（RS-4426）。
  if (sheetType === 'KS') {
    return <FundSheetAnalysisPage />;
  }

  return <ReviewSheetAnalysisContents sheetType={sheetType} />;
};

const ReviewSheetAnalysisContents: FC<Props> = ({ sheetType }) => {
  const { searchQueryStates, isDebouncing } = useAnalysisPageSearchQueryStates({
    useDebounceControl: true,
  });
  const { isLoading } = useProjectsSearchStore();
  return (
    <AnalysisSheetTypeProvider value={sheetType}>
      <Flex vertical gap={16}>
        <AnalysisSegmentSwitcher segment={sheetTypeToSegment[sheetType]} />
        <ProjectsSearchAccordionInitializeStore
          type="analysis"
          searchQueryStates={searchQueryStates}
          isDebouncing={isDebouncing}
        />
        {isLoading ? <AnalysisSearchSkeleton /> : <AnalysisSearchAccordion />}
        {isLoading ? <AnalysisResultsSkeletonContents /> : <AnalysisResults />}
      </Flex>
    </AnalysisSheetTypeProvider>
  );
};
